import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/food-gallery/components/GalleryInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/NavigationBar.tsx");
